import { Link, useLocation } from "react-router-dom";
import usePageMeta from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();
  usePageMeta({
    title: "页面未找到 - 张津瑜个人品牌官网",
    description: "抱歉，您访问的页面不存在或已被移动，请返回首页继续浏览。",
  });

  return (
    <div className="relative flex min-h-[70vh] flex-col items-center justify-center px-4 py-20 text-center">
      <span className="font-label text-[7rem] font-extrabold leading-none text-primary-100 select-none md:text-[10rem]">
        404
      </span>
      <div className="relative z-10 -mt-8 md:-mt-12">
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          抱歉，这个页面走丢了
        </h1>
        <p className="mt-3 text-sm text-foreground-500">当前地址：{location.pathname}</p>
        <p className="mt-2 text-base text-foreground-600">
          您访问的页面不存在或已被移动，不妨回到首页看看最新的内容。
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line text-base" />
          返回首页
        </Link>
      </div>
    </div>
  );
}